export default __webpack_public_path__ + "static/media/logic.ccdeb7bf.svg";